import { browserAnalyticsSettings } from './analytics-browser.mjs';
import { analyticsExplicitlyDenied } from './analytics-parameters.mjs';
import { sendVerifiedLifecycleEvent } from './analytics';
let active = false;
export async function trackLifecycleEvents() {
  const settings = browserAnalyticsSettings();
  if (active || !settings.enabled || analyticsExplicitlyDenied(window, settings.tagId)) return;
  active = true;
  try {
    const response = await fetch('/api/analytics/lifecycle', { method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({operation:'claim'}),signal:AbortSignal.timeout(10000),cache:'no-store' });
    if (!response.ok) return;
    const data = await response.json();
    for (const event of data.events || []) {
      sendVerifiedLifecycleEvent(event.name, event.parameters, event.id, () => {
        void fetch('/api/analytics/lifecycle', {method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({operation:'ack',id:event.id,leaseToken:event.leaseToken}),keepalive:true}).catch(() => {});
      });
    }
  } catch { /* Optional analytics never blocks registration or generation. */ }
  finally { active = false; }
}
